// source: dashboard/dashboard.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.dashboard.AddWidgetRequest', null, global);
goog.exportSymbol('proto.dashboard.CreateDashboardRequest', null, global);
goog.exportSymbol('proto.dashboard.Dashboard', null, global);
goog.exportSymbol('proto.dashboard.DashboardPurpose', null, global);
goog.exportSymbol('proto.dashboard.DeleteDashboardRequest', null, global);
goog.exportSymbol('proto.dashboard.DeleteWidgetRequest', null, global);
goog.exportSymbol('proto.dashboard.Filter', null, global);
goog.exportSymbol('proto.dashboard.Filters', null, global);
goog.exportSymbol('proto.dashboard.GetDashboardRequest', null, global);
goog.exportSymbol('proto.dashboard.GetWidgetRequest', null, global);
goog.exportSymbol('proto.dashboard.ListDashboardsRequest', null, global);
goog.exportSymbol('proto.dashboard.ListDashboardsResponse', null, global);
goog.exportSymbol('proto.dashboard.MoveWidgetRequest', null, global);
goog.exportSymbol('proto.dashboard.UpdateDashboardRequest', null, global);
goog.exportSymbol('proto.dashboard.UpdateWidgetRequest', null, global);
goog.exportSymbol('proto.dashboard.Widget', null, global);
goog.exportSymbol('proto.dashboard.WidgetDataSource', null, global);
goog.exportSymbol('proto.dashboard.WidgetType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.CreateDashboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.CreateDashboardRequest.repeatedFields_, null);
};
goog.inherits(proto.dashboard.CreateDashboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.CreateDashboardRequest.displayName = 'proto.dashboard.CreateDashboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.UpdateDashboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.UpdateDashboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.UpdateDashboardRequest.displayName = 'proto.dashboard.UpdateDashboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.DeleteDashboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.DeleteDashboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.DeleteDashboardRequest.displayName = 'proto.dashboard.DeleteDashboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.AddWidgetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.AddWidgetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.AddWidgetRequest.displayName = 'proto.dashboard.AddWidgetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.DeleteWidgetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.DeleteWidgetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.DeleteWidgetRequest.displayName = 'proto.dashboard.DeleteWidgetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.UpdateWidgetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.UpdateWidgetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.UpdateWidgetRequest.displayName = 'proto.dashboard.UpdateWidgetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.MoveWidgetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.MoveWidgetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.MoveWidgetRequest.displayName = 'proto.dashboard.MoveWidgetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.GetWidgetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.GetWidgetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.GetWidgetRequest.displayName = 'proto.dashboard.GetWidgetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.ListDashboardsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.ListDashboardsRequest.repeatedFields_, null);
};
goog.inherits(proto.dashboard.ListDashboardsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.ListDashboardsRequest.displayName = 'proto.dashboard.ListDashboardsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.ListDashboardsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.ListDashboardsResponse.repeatedFields_, null);
};
goog.inherits(proto.dashboard.ListDashboardsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.ListDashboardsResponse.displayName = 'proto.dashboard.ListDashboardsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.GetDashboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.GetDashboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.GetDashboardRequest.displayName = 'proto.dashboard.GetDashboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.Filters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.Filters.repeatedFields_, null);
};
goog.inherits(proto.dashboard.Filters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.Filters.displayName = 'proto.dashboard.Filters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.Filter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.Filter.repeatedFields_, null);
};
goog.inherits(proto.dashboard.Filter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.Filter.displayName = 'proto.dashboard.Filter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.Dashboard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dashboard.Dashboard.repeatedFields_, null);
};
goog.inherits(proto.dashboard.Dashboard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.Dashboard.displayName = 'proto.dashboard.Dashboard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.Widget = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.Widget, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.Widget.displayName = 'proto.dashboard.Widget';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.CreateDashboardRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.CreateDashboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.CreateDashboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.CreateDashboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.CreateDashboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    width: jspb.Message.getFieldWithDefault(msg, 3, 0),
    height: jspb.Message.getFieldWithDefault(msg, 4, 0),
    purpose: jspb.Message.getFieldWithDefault(msg, 5, 0),
    configuration: jspb.Message.getFieldWithDefault(msg, 6, ""),
    widgetsList: jspb.Message.toObjectList(msg.getWidgetsList(),
    proto.dashboard.Widget.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.CreateDashboardRequest}
 */
proto.dashboard.CreateDashboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.CreateDashboardRequest;
  return proto.dashboard.CreateDashboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.CreateDashboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.CreateDashboardRequest}
 */
proto.dashboard.CreateDashboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 5:
      var value = /** @type {!proto.dashboard.DashboardPurpose} */ (reader.readEnum());
      msg.setPurpose(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfiguration(value);
      break;
    case 7:
      var value = new proto.dashboard.Widget;
      reader.readMessage(value,proto.dashboard.Widget.deserializeBinaryFromReader);
      msg.addWidgets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.CreateDashboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.CreateDashboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.CreateDashboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.CreateDashboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPurpose();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getConfiguration();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getWidgetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.dashboard.Widget.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.dashboard.CreateDashboardRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.dashboard.CreateDashboardRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 width = 3;
 * @return {number}
 */
proto.dashboard.CreateDashboardRequest.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 height = 4;
 * @return {number}
 */
proto.dashboard.CreateDashboardRequest.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional DashboardPurpose purpose = 5;
 * @return {!proto.dashboard.DashboardPurpose}
 */
proto.dashboard.CreateDashboardRequest.prototype.getPurpose = function() {
  return /** @type {!proto.dashboard.DashboardPurpose} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.dashboard.DashboardPurpose} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.setPurpose = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string configuration = 6;
 * @return {string}
 */
proto.dashboard.CreateDashboardRequest.prototype.getConfiguration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.setConfiguration = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated Widget widgets = 7;
 * @return {!Array<!proto.dashboard.Widget>}
 */
proto.dashboard.CreateDashboardRequest.prototype.getWidgetsList = function() {
  return /** @type{!Array<!proto.dashboard.Widget>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dashboard.Widget, 7));
};


/**
 * @param {!Array<!proto.dashboard.Widget>} value
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
*/
proto.dashboard.CreateDashboardRequest.prototype.setWidgetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.dashboard.Widget=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dashboard.Widget}
 */
proto.dashboard.CreateDashboardRequest.prototype.addWidgets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.dashboard.Widget, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.CreateDashboardRequest} returns this
 */
proto.dashboard.CreateDashboardRequest.prototype.clearWidgetsList = function() {
  return this.setWidgetsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.UpdateDashboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.UpdateDashboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.UpdateDashboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.UpdateDashboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    width: jspb.Message.getFieldWithDefault(msg, 4, 0),
    height: jspb.Message.getFieldWithDefault(msg, 5, 0),
    purpose: jspb.Message.getFieldWithDefault(msg, 6, 0),
    configuration: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.UpdateDashboardRequest}
 */
proto.dashboard.UpdateDashboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.UpdateDashboardRequest;
  return proto.dashboard.UpdateDashboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.UpdateDashboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.UpdateDashboardRequest}
 */
proto.dashboard.UpdateDashboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 6:
      var value = /** @type {!proto.dashboard.DashboardPurpose} */ (reader.readEnum());
      msg.setPurpose(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.UpdateDashboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.UpdateDashboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.UpdateDashboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.UpdateDashboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPurpose();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getConfiguration();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 width = 4;
 * @return {number}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 height = 5;
 * @return {number}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional DashboardPurpose purpose = 6;
 * @return {!proto.dashboard.DashboardPurpose}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getPurpose = function() {
  return /** @type {!proto.dashboard.DashboardPurpose} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.dashboard.DashboardPurpose} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setPurpose = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string configuration = 7;
 * @return {string}
 */
proto.dashboard.UpdateDashboardRequest.prototype.getConfiguration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateDashboardRequest} returns this
 */
proto.dashboard.UpdateDashboardRequest.prototype.setConfiguration = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.DeleteDashboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.DeleteDashboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.DeleteDashboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.DeleteDashboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.DeleteDashboardRequest}
 */
proto.dashboard.DeleteDashboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.DeleteDashboardRequest;
  return proto.dashboard.DeleteDashboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.DeleteDashboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.DeleteDashboardRequest}
 */
proto.dashboard.DeleteDashboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.DeleteDashboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.DeleteDashboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.DeleteDashboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.DeleteDashboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.dashboard.DeleteDashboardRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.DeleteDashboardRequest} returns this
 */
proto.dashboard.DeleteDashboardRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.AddWidgetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.AddWidgetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.AddWidgetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.AddWidgetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dashboardId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    position: jspb.Message.getFieldWithDefault(msg, 5, 0),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    description: jspb.Message.getFieldWithDefault(msg, 7, ""),
    type: jspb.Message.getFieldWithDefault(msg, 8, 0),
    width: jspb.Message.getFieldWithDefault(msg, 9, 0),
    height: jspb.Message.getFieldWithDefault(msg, 10, 0),
    data: jspb.Message.getFieldWithDefault(msg, 11, ""),
    configuration: jspb.Message.getFieldWithDefault(msg, 12, ""),
    dataSource: jspb.Message.getFieldWithDefault(msg, 13, 0),
    dataGenerationRule: jspb.Message.getFieldWithDefault(msg, 14, ""),
    filters: (f = msg.getFilters()) && proto.dashboard.Filters.toObject(includeInstance, f),
    auditId: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.AddWidgetRequest}
 */
proto.dashboard.AddWidgetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.AddWidgetRequest;
  return proto.dashboard.AddWidgetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.AddWidgetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.AddWidgetRequest}
 */
proto.dashboard.AddWidgetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDashboardId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPosition(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 8:
      var value = /** @type {!proto.dashboard.WidgetType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfiguration(value);
      break;
    case 13:
      var value = /** @type {!proto.dashboard.WidgetDataSource} */ (reader.readEnum());
      msg.setDataSource(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataGenerationRule(value);
      break;
    case 15:
      var value = new proto.dashboard.Filters;
      reader.readMessage(value,proto.dashboard.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.AddWidgetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.AddWidgetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.AddWidgetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.AddWidgetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDashboardId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getConfiguration();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getDataSource();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getDataGenerationRule();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.dashboard.Filters.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string dashboard_id = 1;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getDashboardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setDashboardId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 position = 5;
 * @return {number}
 */
proto.dashboard.AddWidgetRequest.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional WidgetType type = 8;
 * @return {!proto.dashboard.WidgetType}
 */
proto.dashboard.AddWidgetRequest.prototype.getType = function() {
  return /** @type {!proto.dashboard.WidgetType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.dashboard.WidgetType} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional int32 width = 9;
 * @return {number}
 */
proto.dashboard.AddWidgetRequest.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 height = 10;
 * @return {number}
 */
proto.dashboard.AddWidgetRequest.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string data = 11;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setData = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string configuration = 12;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getConfiguration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setConfiguration = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional WidgetDataSource data_source = 13;
 * @return {!proto.dashboard.WidgetDataSource}
 */
proto.dashboard.AddWidgetRequest.prototype.getDataSource = function() {
  return /** @type {!proto.dashboard.WidgetDataSource} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.dashboard.WidgetDataSource} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setDataSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string data_generation_rule = 14;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getDataGenerationRule = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setDataGenerationRule = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional Filters filters = 15;
 * @return {?proto.dashboard.Filters}
 */
proto.dashboard.AddWidgetRequest.prototype.getFilters = function() {
  return /** @type{?proto.dashboard.Filters} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.Filters, 15));
};


/**
 * @param {?proto.dashboard.Filters|undefined} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
*/
proto.dashboard.AddWidgetRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.AddWidgetRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string audit_id = 16;
 * @return {string}
 */
proto.dashboard.AddWidgetRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.AddWidgetRequest} returns this
 */
proto.dashboard.AddWidgetRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.DeleteWidgetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.DeleteWidgetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.DeleteWidgetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.DeleteWidgetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    widgetId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.DeleteWidgetRequest}
 */
proto.dashboard.DeleteWidgetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.DeleteWidgetRequest;
  return proto.dashboard.DeleteWidgetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.DeleteWidgetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.DeleteWidgetRequest}
 */
proto.dashboard.DeleteWidgetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWidgetId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.DeleteWidgetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.DeleteWidgetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.DeleteWidgetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.DeleteWidgetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWidgetId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string widget_id = 1;
 * @return {string}
 */
proto.dashboard.DeleteWidgetRequest.prototype.getWidgetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.DeleteWidgetRequest} returns this
 */
proto.dashboard.DeleteWidgetRequest.prototype.setWidgetId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.UpdateWidgetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.UpdateWidgetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.UpdateWidgetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.UpdateWidgetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    position: jspb.Message.getFieldWithDefault(msg, 4, 0),
    type: jspb.Message.getFieldWithDefault(msg, 5, 0),
    width: jspb.Message.getFieldWithDefault(msg, 6, 0),
    height: jspb.Message.getFieldWithDefault(msg, 7, 0),
    data: jspb.Message.getFieldWithDefault(msg, 8, ""),
    configuration: jspb.Message.getFieldWithDefault(msg, 9, ""),
    dataSource: jspb.Message.getFieldWithDefault(msg, 10, 0),
    dataGenerationRule: jspb.Message.getFieldWithDefault(msg, 11, ""),
    filters: (f = msg.getFilters()) && proto.dashboard.Filters.toObject(includeInstance, f),
    auditId: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.UpdateWidgetRequest}
 */
proto.dashboard.UpdateWidgetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.UpdateWidgetRequest;
  return proto.dashboard.UpdateWidgetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.UpdateWidgetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.UpdateWidgetRequest}
 */
proto.dashboard.UpdateWidgetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPosition(value);
      break;
    case 5:
      var value = /** @type {!proto.dashboard.WidgetType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfiguration(value);
      break;
    case 10:
      var value = /** @type {!proto.dashboard.WidgetDataSource} */ (reader.readEnum());
      msg.setDataSource(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataGenerationRule(value);
      break;
    case 12:
      var value = new proto.dashboard.Filters;
      reader.readMessage(value,proto.dashboard.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.UpdateWidgetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.UpdateWidgetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.UpdateWidgetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.UpdateWidgetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getConfiguration();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDataSource();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getDataGenerationRule();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.dashboard.Filters.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 position = 4;
 * @return {number}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional WidgetType type = 5;
 * @return {!proto.dashboard.WidgetType}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getType = function() {
  return /** @type {!proto.dashboard.WidgetType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.dashboard.WidgetType} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int32 width = 6;
 * @return {number}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 height = 7;
 * @return {number}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string data = 8;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setData = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string configuration = 9;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getConfiguration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setConfiguration = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional WidgetDataSource data_source = 10;
 * @return {!proto.dashboard.WidgetDataSource}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getDataSource = function() {
  return /** @type {!proto.dashboard.WidgetDataSource} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.dashboard.WidgetDataSource} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setDataSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string data_generation_rule = 11;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getDataGenerationRule = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setDataGenerationRule = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional Filters filters = 12;
 * @return {?proto.dashboard.Filters}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getFilters = function() {
  return /** @type{?proto.dashboard.Filters} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.Filters, 12));
};


/**
 * @param {?proto.dashboard.Filters|undefined} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
*/
proto.dashboard.UpdateWidgetRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.UpdateWidgetRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string audit_id = 13;
 * @return {string}
 */
proto.dashboard.UpdateWidgetRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.UpdateWidgetRequest} returns this
 */
proto.dashboard.UpdateWidgetRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.MoveWidgetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.MoveWidgetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.MoveWidgetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.MoveWidgetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    widgetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    newPosition: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.MoveWidgetRequest}
 */
proto.dashboard.MoveWidgetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.MoveWidgetRequest;
  return proto.dashboard.MoveWidgetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.MoveWidgetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.MoveWidgetRequest}
 */
proto.dashboard.MoveWidgetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWidgetId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNewPosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.MoveWidgetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.MoveWidgetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.MoveWidgetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.MoveWidgetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWidgetId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNewPosition();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string widget_id = 1;
 * @return {string}
 */
proto.dashboard.MoveWidgetRequest.prototype.getWidgetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.MoveWidgetRequest} returns this
 */
proto.dashboard.MoveWidgetRequest.prototype.setWidgetId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 new_position = 2;
 * @return {number}
 */
proto.dashboard.MoveWidgetRequest.prototype.getNewPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.MoveWidgetRequest} returns this
 */
proto.dashboard.MoveWidgetRequest.prototype.setNewPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.GetWidgetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.GetWidgetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.GetWidgetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetWidgetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    widgetId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    widgetName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dashboardName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    filters: (f = msg.getFilters()) && proto.dashboard.Filters.toObject(includeInstance, f),
    includeData: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    auditId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.GetWidgetRequest}
 */
proto.dashboard.GetWidgetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.GetWidgetRequest;
  return proto.dashboard.GetWidgetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.GetWidgetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.GetWidgetRequest}
 */
proto.dashboard.GetWidgetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWidgetId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWidgetName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDashboardName(value);
      break;
    case 4:
      var value = new proto.dashboard.Filters;
      reader.readMessage(value,proto.dashboard.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeData(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.GetWidgetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.GetWidgetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.GetWidgetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetWidgetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWidgetId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWidgetName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDashboardName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.dashboard.Filters.serializeBinaryToWriter
    );
  }
  f = message.getIncludeData();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string widget_id = 1;
 * @return {string}
 */
proto.dashboard.GetWidgetRequest.prototype.getWidgetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetWidgetRequest} returns this
 */
proto.dashboard.GetWidgetRequest.prototype.setWidgetId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string widget_name = 2;
 * @return {string}
 */
proto.dashboard.GetWidgetRequest.prototype.getWidgetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetWidgetRequest} returns this
 */
proto.dashboard.GetWidgetRequest.prototype.setWidgetName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string dashboard_name = 3;
 * @return {string}
 */
proto.dashboard.GetWidgetRequest.prototype.getDashboardName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetWidgetRequest} returns this
 */
proto.dashboard.GetWidgetRequest.prototype.setDashboardName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Filters filters = 4;
 * @return {?proto.dashboard.Filters}
 */
proto.dashboard.GetWidgetRequest.prototype.getFilters = function() {
  return /** @type{?proto.dashboard.Filters} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.Filters, 4));
};


/**
 * @param {?proto.dashboard.Filters|undefined} value
 * @return {!proto.dashboard.GetWidgetRequest} returns this
*/
proto.dashboard.GetWidgetRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.GetWidgetRequest} returns this
 */
proto.dashboard.GetWidgetRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.GetWidgetRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool include_data = 5;
 * @return {boolean}
 */
proto.dashboard.GetWidgetRequest.prototype.getIncludeData = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard.GetWidgetRequest} returns this
 */
proto.dashboard.GetWidgetRequest.prototype.setIncludeData = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string audit_id = 6;
 * @return {string}
 */
proto.dashboard.GetWidgetRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetWidgetRequest} returns this
 */
proto.dashboard.GetWidgetRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.ListDashboardsRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.ListDashboardsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.ListDashboardsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.ListDashboardsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.ListDashboardsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    namesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    includeData: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    filters: (f = msg.getFilters()) && proto.dashboard.Filters.toObject(includeInstance, f),
    auditId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.ListDashboardsRequest}
 */
proto.dashboard.ListDashboardsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.ListDashboardsRequest;
  return proto.dashboard.ListDashboardsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.ListDashboardsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.ListDashboardsRequest}
 */
proto.dashboard.ListDashboardsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addNames(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeData(value);
      break;
    case 4:
      var value = new proto.dashboard.Filters;
      reader.readMessage(value,proto.dashboard.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.ListDashboardsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.ListDashboardsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.ListDashboardsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.ListDashboardsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getIncludeData();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.dashboard.Filters.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.dashboard.ListDashboardsRequest.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};


/**
 * repeated string names = 2;
 * @return {!Array<string>}
 */
proto.dashboard.ListDashboardsRequest.prototype.getNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.setNamesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.addNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.clearNamesList = function() {
  return this.setNamesList([]);
};


/**
 * optional bool include_data = 3;
 * @return {boolean}
 */
proto.dashboard.ListDashboardsRequest.prototype.getIncludeData = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.setIncludeData = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional Filters filters = 4;
 * @return {?proto.dashboard.Filters}
 */
proto.dashboard.ListDashboardsRequest.prototype.getFilters = function() {
  return /** @type{?proto.dashboard.Filters} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.Filters, 4));
};


/**
 * @param {?proto.dashboard.Filters|undefined} value
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
*/
proto.dashboard.ListDashboardsRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.ListDashboardsRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string audit_id = 5;
 * @return {string}
 */
proto.dashboard.ListDashboardsRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.ListDashboardsRequest} returns this
 */
proto.dashboard.ListDashboardsRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.ListDashboardsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.ListDashboardsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.ListDashboardsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.ListDashboardsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.ListDashboardsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    dashboardsList: jspb.Message.toObjectList(msg.getDashboardsList(),
    proto.dashboard.Dashboard.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.ListDashboardsResponse}
 */
proto.dashboard.ListDashboardsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.ListDashboardsResponse;
  return proto.dashboard.ListDashboardsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.ListDashboardsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.ListDashboardsResponse}
 */
proto.dashboard.ListDashboardsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.dashboard.Dashboard;
      reader.readMessage(value,proto.dashboard.Dashboard.deserializeBinaryFromReader);
      msg.addDashboards(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.ListDashboardsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.ListDashboardsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.ListDashboardsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.ListDashboardsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDashboardsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.dashboard.Dashboard.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Dashboard dashboards = 1;
 * @return {!Array<!proto.dashboard.Dashboard>}
 */
proto.dashboard.ListDashboardsResponse.prototype.getDashboardsList = function() {
  return /** @type{!Array<!proto.dashboard.Dashboard>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dashboard.Dashboard, 1));
};


/**
 * @param {!Array<!proto.dashboard.Dashboard>} value
 * @return {!proto.dashboard.ListDashboardsResponse} returns this
*/
proto.dashboard.ListDashboardsResponse.prototype.setDashboardsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.dashboard.Dashboard=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dashboard.Dashboard}
 */
proto.dashboard.ListDashboardsResponse.prototype.addDashboards = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.dashboard.Dashboard, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.ListDashboardsResponse} returns this
 */
proto.dashboard.ListDashboardsResponse.prototype.clearDashboardsList = function() {
  return this.setDashboardsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.GetDashboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.GetDashboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.GetDashboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    includeData: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    filters: (f = msg.getFilters()) && proto.dashboard.Filters.toObject(includeInstance, f),
    auditId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.GetDashboardRequest}
 */
proto.dashboard.GetDashboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.GetDashboardRequest;
  return proto.dashboard.GetDashboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.GetDashboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.GetDashboardRequest}
 */
proto.dashboard.GetDashboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeData(value);
      break;
    case 4:
      var value = new proto.dashboard.Filters;
      reader.readMessage(value,proto.dashboard.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.GetDashboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.GetDashboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.GetDashboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.GetDashboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIncludeData();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.dashboard.Filters.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.dashboard.GetDashboardRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetDashboardRequest} returns this
 */
proto.dashboard.GetDashboardRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.dashboard.GetDashboardRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetDashboardRequest} returns this
 */
proto.dashboard.GetDashboardRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool include_data = 3;
 * @return {boolean}
 */
proto.dashboard.GetDashboardRequest.prototype.getIncludeData = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard.GetDashboardRequest} returns this
 */
proto.dashboard.GetDashboardRequest.prototype.setIncludeData = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional Filters filters = 4;
 * @return {?proto.dashboard.Filters}
 */
proto.dashboard.GetDashboardRequest.prototype.getFilters = function() {
  return /** @type{?proto.dashboard.Filters} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.Filters, 4));
};


/**
 * @param {?proto.dashboard.Filters|undefined} value
 * @return {!proto.dashboard.GetDashboardRequest} returns this
*/
proto.dashboard.GetDashboardRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.GetDashboardRequest} returns this
 */
proto.dashboard.GetDashboardRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.GetDashboardRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string audit_id = 5;
 * @return {string}
 */
proto.dashboard.GetDashboardRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.GetDashboardRequest} returns this
 */
proto.dashboard.GetDashboardRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.Filters.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.Filters.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.Filters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.Filters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Filters.toObject = function(includeInstance, msg) {
  var f, obj = {
    starttime: jspb.Message.getFieldWithDefault(msg, 1, 0),
    endtime: jspb.Message.getFieldWithDefault(msg, 2, 0),
    filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.dashboard.Filter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.Filters}
 */
proto.dashboard.Filters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.Filters;
  return proto.dashboard.Filters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.Filters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.Filters}
 */
proto.dashboard.Filters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStarttime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtime(value);
      break;
    case 3:
      var value = new proto.dashboard.Filter;
      reader.readMessage(value,proto.dashboard.Filter.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.Filters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.Filters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.Filters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Filters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStarttime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEndtime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.dashboard.Filter.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 startTime = 1;
 * @return {number}
 */
proto.dashboard.Filters.prototype.getStarttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Filters} returns this
 */
proto.dashboard.Filters.prototype.setStarttime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 endTime = 2;
 * @return {number}
 */
proto.dashboard.Filters.prototype.getEndtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Filters} returns this
 */
proto.dashboard.Filters.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated Filter filters = 3;
 * @return {!Array<!proto.dashboard.Filter>}
 */
proto.dashboard.Filters.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.dashboard.Filter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dashboard.Filter, 3));
};


/**
 * @param {!Array<!proto.dashboard.Filter>} value
 * @return {!proto.dashboard.Filters} returns this
*/
proto.dashboard.Filters.prototype.setFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.dashboard.Filter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dashboard.Filter}
 */
proto.dashboard.Filters.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.dashboard.Filter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.Filters} returns this
 */
proto.dashboard.Filters.prototype.clearFiltersList = function() {
  return this.setFiltersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.Filter.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.Filter.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.Filter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.Filter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Filter.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    valuesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.Filter}
 */
proto.dashboard.Filter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.Filter;
  return proto.dashboard.Filter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.Filter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.Filter}
 */
proto.dashboard.Filter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.Filter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.Filter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.Filter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Filter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.dashboard.Filter.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Filter} returns this
 */
proto.dashboard.Filter.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string values = 2;
 * @return {!Array<string>}
 */
proto.dashboard.Filter.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.dashboard.Filter} returns this
 */
proto.dashboard.Filter.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.dashboard.Filter} returns this
 */
proto.dashboard.Filter.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.Filter} returns this
 */
proto.dashboard.Filter.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dashboard.Dashboard.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.Dashboard.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.Dashboard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.Dashboard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Dashboard.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdBy: jspb.Message.getFieldWithDefault(msg, 4, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    description: jspb.Message.getFieldWithDefault(msg, 7, ""),
    widgetsList: jspb.Message.toObjectList(msg.getWidgetsList(),
    proto.dashboard.Widget.toObject, includeInstance),
    width: jspb.Message.getFieldWithDefault(msg, 9, 0),
    height: jspb.Message.getFieldWithDefault(msg, 10, 0),
    purpose: jspb.Message.getFieldWithDefault(msg, 11, 0),
    configuration: jspb.Message.getFieldWithDefault(msg, 12, ""),
    availableFilters: (f = msg.getAvailableFilters()) && proto.dashboard.Filters.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.Dashboard}
 */
proto.dashboard.Dashboard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.Dashboard;
  return proto.dashboard.Dashboard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.Dashboard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.Dashboard}
 */
proto.dashboard.Dashboard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 8:
      var value = new proto.dashboard.Widget;
      reader.readMessage(value,proto.dashboard.Widget.deserializeBinaryFromReader);
      msg.addWidgets(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 11:
      var value = /** @type {!proto.dashboard.DashboardPurpose} */ (reader.readEnum());
      msg.setPurpose(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfiguration(value);
      break;
    case 13:
      var value = new proto.dashboard.Filters;
      reader.readMessage(value,proto.dashboard.Filters.deserializeBinaryFromReader);
      msg.setAvailableFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.Dashboard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.Dashboard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.Dashboard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Dashboard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getWidgetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.dashboard.Widget.serializeBinaryToWriter
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getPurpose();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getConfiguration();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAvailableFilters();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.dashboard.Filters.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.dashboard.Dashboard.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.dashboard.Dashboard.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.dashboard.Dashboard} returns this
*/
proto.dashboard.Dashboard.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.Dashboard.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.dashboard.Dashboard.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.dashboard.Dashboard} returns this
*/
proto.dashboard.Dashboard.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.Dashboard.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string created_by = 4;
 * @return {string}
 */
proto.dashboard.Dashboard.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string account_id = 5;
 * @return {string}
 */
proto.dashboard.Dashboard.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.dashboard.Dashboard.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.dashboard.Dashboard.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated Widget widgets = 8;
 * @return {!Array<!proto.dashboard.Widget>}
 */
proto.dashboard.Dashboard.prototype.getWidgetsList = function() {
  return /** @type{!Array<!proto.dashboard.Widget>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dashboard.Widget, 8));
};


/**
 * @param {!Array<!proto.dashboard.Widget>} value
 * @return {!proto.dashboard.Dashboard} returns this
*/
proto.dashboard.Dashboard.prototype.setWidgetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.dashboard.Widget=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dashboard.Widget}
 */
proto.dashboard.Dashboard.prototype.addWidgets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.dashboard.Widget, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.clearWidgetsList = function() {
  return this.setWidgetsList([]);
};


/**
 * optional int32 width = 9;
 * @return {number}
 */
proto.dashboard.Dashboard.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 height = 10;
 * @return {number}
 */
proto.dashboard.Dashboard.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional DashboardPurpose purpose = 11;
 * @return {!proto.dashboard.DashboardPurpose}
 */
proto.dashboard.Dashboard.prototype.getPurpose = function() {
  return /** @type {!proto.dashboard.DashboardPurpose} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.dashboard.DashboardPurpose} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setPurpose = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional string configuration = 12;
 * @return {string}
 */
proto.dashboard.Dashboard.prototype.getConfiguration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.setConfiguration = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional Filters available_filters = 13;
 * @return {?proto.dashboard.Filters}
 */
proto.dashboard.Dashboard.prototype.getAvailableFilters = function() {
  return /** @type{?proto.dashboard.Filters} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.Filters, 13));
};


/**
 * @param {?proto.dashboard.Filters|undefined} value
 * @return {!proto.dashboard.Dashboard} returns this
*/
proto.dashboard.Dashboard.prototype.setAvailableFilters = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.Dashboard} returns this
 */
proto.dashboard.Dashboard.prototype.clearAvailableFilters = function() {
  return this.setAvailableFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.Dashboard.prototype.hasAvailableFilters = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.Widget.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.Widget.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.Widget} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Widget.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdBy: jspb.Message.getFieldWithDefault(msg, 4, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    description: jspb.Message.getFieldWithDefault(msg, 7, ""),
    position: jspb.Message.getFieldWithDefault(msg, 8, 0),
    type: jspb.Message.getFieldWithDefault(msg, 9, 0),
    width: jspb.Message.getFieldWithDefault(msg, 10, 0),
    height: jspb.Message.getFieldWithDefault(msg, 11, 0),
    data: jspb.Message.getFieldWithDefault(msg, 12, ""),
    configuration: jspb.Message.getFieldWithDefault(msg, 13, ""),
    dataSource: jspb.Message.getFieldWithDefault(msg, 14, 0),
    dataGenerationRule: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.Widget}
 */
proto.dashboard.Widget.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.Widget;
  return proto.dashboard.Widget.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.Widget} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.Widget}
 */
proto.dashboard.Widget.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPosition(value);
      break;
    case 9:
      var value = /** @type {!proto.dashboard.WidgetType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfiguration(value);
      break;
    case 14:
      var value = /** @type {!proto.dashboard.WidgetDataSource} */ (reader.readEnum());
      msg.setDataSource(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataGenerationRule(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.Widget.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.Widget.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.Widget} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.Widget.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getConfiguration();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getDataSource();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getDataGenerationRule();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.dashboard.Widget.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.dashboard.Widget} returns this
*/
proto.dashboard.Widget.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.Widget.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.dashboard.Widget.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.dashboard.Widget} returns this
*/
proto.dashboard.Widget.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.Widget.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string created_by = 4;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string account_id = 5;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 position = 8;
 * @return {number}
 */
proto.dashboard.Widget.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional WidgetType type = 9;
 * @return {!proto.dashboard.WidgetType}
 */
proto.dashboard.Widget.prototype.getType = function() {
  return /** @type {!proto.dashboard.WidgetType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.dashboard.WidgetType} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional int32 width = 10;
 * @return {number}
 */
proto.dashboard.Widget.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 height = 11;
 * @return {number}
 */
proto.dashboard.Widget.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string data = 12;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setData = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string configuration = 13;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getConfiguration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setConfiguration = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional WidgetDataSource data_source = 14;
 * @return {!proto.dashboard.WidgetDataSource}
 */
proto.dashboard.Widget.prototype.getDataSource = function() {
  return /** @type {!proto.dashboard.WidgetDataSource} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.dashboard.WidgetDataSource} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setDataSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional string data_generation_rule = 15;
 * @return {string}
 */
proto.dashboard.Widget.prototype.getDataGenerationRule = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.Widget} returns this
 */
proto.dashboard.Widget.prototype.setDataGenerationRule = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * @enum {number}
 */
proto.dashboard.DashboardPurpose = {
  ANY_SECTIONS: 0,
  CONTROL_LIST_SECTION: 1,
  DASHBOARD_SECTION: 2
};

/**
 * @enum {number}
 */
proto.dashboard.WidgetDataSource = {
  UNDEFINED_SOURCE: 0,
  DATA_AS_SOURCE: 1,
  RULE_AS_SOURCE: 2,
  DQL_AS_SOURCE: 3
};

/**
 * @enum {number}
 */
proto.dashboard.WidgetType = {
  CHART_WIDGET: 0,
  TABLE_WIDGET: 1,
  TEXT_WIDGET: 2
};

goog.object.extend(exports, proto.dashboard);
